function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import initSchemaLoggerUsersEvents from '@wix/bi-logger-photo-users';
import initSchemaLoggerUsersOfUsersEvents from '@wix/bi-logger-photo-ugc';
import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';
import { baseUtils } from './baseUtils';
import Wix from '../sdk/WixSdkWrapper';
import window from '../sdk/windowWrapper';
var emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

var omitEmails = function omitEmails(obj, str) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      obj[key] = obj[key].replace(emailRegex, str);
    }
  }
};

var BiLogger = /*#__PURE__*/function () {
  /* @ngInject */
  function BiLogger() {
    //this.initVisitorId();
    var factory = iframeAppBiLoggerFactory(Wix);
    this.biLoggerUsersEvents = initSchemaLoggerUsersEvents(factory)();
    this.biLoggerUsersOfusersEvents = initSchemaLoggerUsersOfUsersEvents(factory)();

    if (!baseUtils.isTest() && !baseUtils.isOOI()) {
      try {
        var galleryId = this.getParam('galleryId');
        this.biLoggerUsersEvents.util.updateDefaults({
          gallery_id: galleryId
        });
        this.biLoggerUsersOfusersEvents.util.updateDefaults({
          gallery_id: galleryId
        });
      } catch (e) {
        console.error('getParam(\'galleryId\'):', e);
      }
    }

    try {
      this.protocol = window.location.protocol;
      this.performance = window.performance;
    } catch (e) {
      this.protocol = 'http:';
      this.performance = false;
    }

    this.usersEvents = ['proGallerySettingsStartNow', // 182
    'addProGallery', // 400
    'changeSettings', // 401
    'mangeMediaUpperPanelOpen', // 402
    'proGallerySettingsLoaded', // 403
    'manageMediaSet', // 404
    'manageMediaTextEditorCustomize', // 405
    'uploadMedia', // 406
    'uploadMediaError', // 407
    'removeMedia', // 408
    'layoutsSelect', // 409
    'galleryPerformance', // 410
    'proGallerySettingsNavigation', // 411
    'galleryPublished', // 412
    'customizeLayout', // 413
    'organizeMediaEditQualityClick', // 420
    'singleImageSettingsApply', // 421
    'singleImageSettingsCancel', // 422
    'organizeMediaReplaceImage', // 423
    'manageMediaClick', // 700
    'storeSetUpClick', // 702
    'expandSettings', // 703
    'expandModeDone', // 704
    'watermarkSettings', // 705
    'watermarkEnable', // 706
    'cartSettings', // 708
    'cartDesignTab', // 709
    'artStoreDashboardNavigation', // 727
    'artStoreSaveBusinessInfo', // 728
    'artStoreStartNow', // 729
    'artStoreChooseSellingMethod', // 730
    'artStoreConnectProvider', // 734
    'supportQuestionClick' // 901
    ];
    this.usersOfusersEvents = ['share', // 500
    'love', // 501
    'download', // 502
    'info', // 503
    'expand', // 504
    'paymentExcepted', // 506
    'paymentError', // 507
    'proGalleryLoadError', // 509
    'proGalleryLoaded', // 510
    'proGalleryErrorUou', // 512
    'galleryClickOnItem', // 520
    'galleryItemExpanded', // 521
    'selectPhoto', // 600
    'shareGroup', // 601
    'buyBuyNowClick' // 800
    ];
    this.log = this.log.bind(this);
  }

  var _proto = BiLogger.prototype;

  _proto.isUserEvent = function isUserEvent(funcName) {
    return this.usersEvents.includes(funcName);
  };

  _proto.isUserOfUserEvent = function isUserOfUserEvent(funcName) {
    return this.usersOfusersEvents.includes(funcName);
  };

  _proto.log = function log(funcName, data) {
    if (data === void 0) {
      data = {};
    }

    if (baseUtils.isOOI()) {
      return;
    }

    try {
      var initialData = {
        galleryType: this.getGalleryType()
      };

      var logData = _objectSpread(_objectSpread({}, initialData), data);

      if (this.isUserEvent(funcName)) {
        if (funcName === 'manageMediaSet') {
          omitEmails(data, '-omitted email-');
        }

        if (this.biLoggerUsersEvents[funcName]) {
          this.biLoggerUsersEvents[funcName](logData);
        }
      } else if (this.isUserOfUserEvent(funcName)) {
        //logData = { ...logData, ...{ visitor_id: this.visitorId } };
        if (this.biLoggerUsersOfusersEvents[funcName]) {
          this.biLoggerUsersOfusersEvents[funcName](logData);
        }
      } else {
        console.log('bi event is not categorized');
      }
    } catch (e) {
      console.log('Error bi logger', e);
    }
  };

  _proto.getGalleryType = function getGalleryType() {
    return baseUtils.isStoreGallery() ? 'store' : 'progallery';
  };

  _proto.initVisitorId = function initVisitorId() {
    var _this = this;

    // function is not working for OOI correctly
    if (baseUtils.isOOI()) {
      return;
    }

    if (typeof Promise === 'undefined') {
      console.error('promise is undefined in initVisitorId. Cant init visitor id');
      return;
    }

    var timeOut = 9000;
    var beginTime = Date.now();
    new Promise(function (resolve) {
      return resolve(Wix.Utils.getInstanceValue('aid') || Wix.Utils.getInstanceValue('uid'));
    }).then(function (val) {
      _this.visitorId = val;
      var interval = Date.now() - beginTime;

      if (interval > timeOut) {
        console.error("took over " + timeOut + "ms to get the visitor id", interval + 'ms');
      }
    })["catch"](function (err) {
      return console.error('cant get visitorID/sessionToken', err);
    });
    setTimeout(function () {
      if (!_this.visitorId) {
        console.error("waiting " + timeOut + "ms for visitorID/sessionToken");
      }
    }, timeOut);
  };

  _proto.getParam = function getParam(val) {
    var vmDefaultStringRegex = /^\$\{.*\}$/; // e.g. "${instance}" or "${some_variable}"

    var windowVal = String(window[val]);

    if (windowVal && vmDefaultStringRegex.exec(windowVal) === null) {
      return windowVal;
    } else {
      var result = '',
          tmp = [];
      location.search // .replace ( "?", "" )
      // this is better, there might be a question mark inside
      .substr(1).split('&').forEach(function (item) {
        tmp = item.split('=');

        if (tmp[0] === val) {
          result = decodeURIComponent(tmp[1]);
        }
      });
      return result;
    }
  };

  return BiLogger;
}();

export var logger = new BiLogger();